export default {
    msg: {
        /* 翻译 -------------------------------------开始 */
        // 通用
        "空": "空",
        "暂无数据": "暂无数据",
        "安装包列表": "安装包列表",
        "显示器列表": "显示器列表",
        "设置-配置文件": "设置-配置文件",
        "用户管理": "用户管理",
        "操作记录": "操作记录",
        "退出": "退出",
        "共": "共",
        "页": "页",
        "前往": "前往",
        "上一页": "上一页",
        "下一页": "下一页",
        "请输入前往页数": "请输入前往页数",
        "用户配置": "用户配置",
        "语言模式": "语言模式",
        "头像": "头像",
        "请输入x": "请输入{param}",
        "请选择x": "请选择{param}",
        "原密码": "原密码",
        "新密码": "新密码",
        "确认新密码": "确认新密码",
        "输入的两次密码不一致": "输入的两次密码不一致",
        "请输入确认新密码，密码与新密码一致": "请输入确认新密码，密码与新密码一致",
        "请求参数不正确:密码长度为 8-16 位": "请求参数不正确:密码长度为 8-16 位",
        "联想隐私声明": "联想隐私声明",
        "联想软件许可协议": "联想软件许可协议",
        "第三方通知": "第三方通知",
        "修改密码": "修改密码",
        "修改个人信息": "修改个人信息",
        "成功退出": "成功退出",
        "管理员": "管理员",
        "普通用户": "普通用户",
        "机型": "机型",
        "确认删除此信息吗？": "确认删除此信息吗？",
        "请输入新密码，密码由大写字母，小写字母，数字，特殊字符组成，且至少包3种": "请输入新密码，密码由大写字母，小写字母，数字，特殊字符组成，且至少包3种",
        "提示": "提示",
        "确 定": "确 定",
        "取 消": "取 消",
        "删除成功": "删除成功",
        "修改成功": "修改成功",
        "请选择正确的文件类型": "请选择正确的文件类型",
        "上传文件大于100MB，请重新选择": "上传文件大于100MB，请重新选择",
        "数据正在处理，请勿重复提交": "数据正在处理，请勿重复提交！",
        "当前登录状态已过期，请重新登录": "当前登录状态已过期，请重新登录！",
        "网络请求地址不正确": "网络请求地址不正确！",
        "服务器发生未知错误": "服务器发生未知错误！",
        "发生未知错误": "发生未知错误！",
        "请求服务超时,可能没有网络，请重新操作": "请求服务超时,可能没有网络，请重新操作！",
        "非法请求头": "非法请求头！",
        "未能连接至服务器": "未能连接至服务器",
        "当前可能处于网络未连接状态": "当前可能处于网络未连接状态",
        "没有找到相关设备": "没有找到相关设备",
        "设备中预升级组件未找到": "设备中预升级组件未找到",
        "安装组件FWID未找到": "安装组件FWID未找到",
        "升级信息设置失败": "升级信息设置失败",
        "指定更新设置失败": "指定更新设置失败",
        "更新包安装失败": "更新包安装失败",
        "设备句柄获取失败": "设备句柄获取失败",
        "升级设备不匹配": "升级设备不匹配",
        "无法安装:设备中没有找到预升级组件": "无法安装:设备中没有找到预升级组件",
        "无法安装:组件中FWID不匹配": "无法安装:组件中FWID不匹配",
        "无法安装:未找到升级匹配的显示器": "无法安装:未找到升级匹配的显示器",
        "显示器不存在": "显示器不存在",
        "命令已经下发": "命令已经下发",
        "组不存在": "组不存在",
        "命令不存在": "命令不存在",
        "设置不存在": "设置不存在",
        "设置详情不存在": "设置详情不存在",
        "升级包不存在": "升级包不存在",
  
        "密码格式不正确，密码长度必须在8到30个字符之间": "密码格式不正确，密码长度必须在8到30个字符之间",
        "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型": "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型",
        "参数为空": "参数为空",
        "升级时间不能为空": "升级时间不能为空",
        "升级时间格式不正确,不能小于当前时间或超过当前时间30天": "升级时间格式不正确,不能小于当前时间或超过当前时间30天",
        "上传文件为空": "上传文件为空",
        "上传文件格式不正确,文件格式只能为zip/exe/dmg/app": "上传文件格式不正确,文件格式只能为zip/exe/dmg/app",
        "上传文件格式不正确,文件不能没有后缀": "上传文件格式不正确,文件不能没有后缀",
        "登录失败，账号密码不正确": "登录失败，账号密码不正确",
        "日期": "日期",
        "时间": "时间",
        "此操作将永久删除当前数据, 是否继续?": "此操作将永久删除当前数据, 是否继续?",
        "请先选中一项再删除": "请先选中一项再删除",
        "开始下载": "开始下载",
        "密码错误": "密码错误",
        "修改密码成功": "修改密码成功",
        "正在下载文件中": "正在下载文件中...",
        "显示器id或组id为空": "显示器id或组id为空",
        "升级包记录id为空": "升级包记录id为空",
        "用户名已存在": "用户名已存在",
        "该显示器设置命令正在执行中，请等待10s后，再进行新的设置": "该显示器设置命令正在执行中，请等待10s后，再进行新的设置",
        "关闭": "关闭",
        "角色不存在，无法修改角色": "角色不存在，无法修改角色",
        "未知命令": "未知命令",
        "访问令牌已过期": "访问令牌已过期",
        "请求参数不正确:": "请求参数不正确:",
        "无效的刷新令牌": "无效的刷新令牌",
        "请求参数缺失:": "请求参数缺失:",
        "请求参数类型错误:": "请求参数类型错误:",
        "请求参数不正确:": "请求参数不正确:",
        "请求地址不存在:": "请求地址不存在:",
        "请求方法不正确:": "请求方法不正确:",
        // 登录
        '登录': '登 录',
        '账号': '账号',
        '密码': '密码',
        "升级失败": "升级失败",
        '重置密码': '重置密码？',
        '输入字符在x个字符以内': '输入字符在{param}个字符以内',
        "登录成功": "登录成功",
        "请联系管理员，进行密码重置": "请联系管理员，进行密码重置",
        "重试超过5次，请30分钟后再试": "重试超过5次，请30分钟后再试",
        // 显示器列表
        "请输入型号/主机名/固件版本号": "请输入型号/主机名/固件版本号",
        "创建组": "创建组",
        "删除组": "删除组",
        "显示列": "显示列",
        "折叠": "折叠",
        "展开": "展开",
        "移动组": "移动组",
        "导出": "导出",
        "开启电源": "开启电源",
        "关闭电源": "关闭电源",
        "屏幕锁定": "屏幕锁定",
        "屏幕解锁": "屏幕解锁",
        "设置": "设置",
        "导出设置配置文件": "导出设置配置文件",
        "升级": "升级",
        "删除显示器": "删除显示器",
        "设备总数量": "设备总数量",
        "设备选中量": "设备选中量",
        "请选择更新包": "请选择更新包",
        "更新包名": "更新包名",
        "更新时间": "更新时间",
        "应用于同型号显示器": "应用于同型号显示器",
        "时间": "时间",
        "显示设置": "显示设置",
        "全选": "全选",
        "设置配置文件": "设置配置文件",
        "文件名": "文件名",
        "组": "组",
        "显示器型号": "显示器型号",
        "特殊ID": "特殊ID",
        "主机名称": "主机名称",
        "主机状态": "主机状态",
        "显示器状态": "显示器状态",
        "锁定状态": "锁定状态",
        "升级进度": "升级进度",
        "创建设置": "创建设置",
        "提示信息": "提示信息",
        "使用时长": "使用时长",
        "超频": "超频",
        "操作成功": "操作成功",
        "请先保存数据": "请先保存数据",
        "请先选中组或显示器": "请先选中组或显示器",
        "未分组无法修改": "未分组无法修改",
        "取消全选": "取消全选",
        "请选中GAMMA节点标签的值": "请选中GAMMA节点标签的值",
        "未分组": "未分组",
        "离线": "离线",
        "在线": "在线",
        "开机": "开机",
        "关机": "关机",
        "锁定": "锁定",
        "未锁定": "未锁定",
        "未连接": "未连接",
        "连接": "连接",
        "设置开始的升级时间": "设置开始的升级时间",
        "现在": "现在",
        "设置升级模式": "设置升级模式",
        "交互模式": "交互模式",
        "静默模式": "静默模式",
        "在这种模式下，用户将会看到显示器固件更新界面，需要用户确认，更新才会进行。用户有两次选择延迟执行的机会，两次延退过后，将强制执行更新。": "在这种模式下，用户将会看到显示器固件更新界面，需要用户确认，更新才会进行。用户有两次选择延迟执行的机会，两次延退过后，将强制执行更新。",
        "在这种模式下，当显示器在线时，新的圆件会以后台的方式立即更新到显示器，用户看不到任何界面，但是新的同件直到显示器重启后才会生效。显示器重启大概需要几秒钟的时间，它不会影响用户电脑上当前进行的任务。": "在这种模式下，当显示器在线时，新的圆件会以后台的方式立即更新到显示器，用户看不到任何界面，但是新的同件直到显示器重启后才会生效。显示器重启大概需要几秒钟的时间，它不会影响用户电脑上当前进行的任务。",
        "请求参数不正确": "请求参数不正确",
        "账号未登录": "账号未登录",
        "请根据您的企业使用显示器的实际情况，选择您期望的显示器重启时机。": "请根据您的企业使用显示器的实际情况，选择您期望的显示器重启时机。",
        "您点击的仍是设备现属组，若要移动，请选其他组。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "请输入组名称": "请输入组名称",
        "应用设置配置文件": "应用设置配置文件：",
        "有新版本，可以去升级": "有新版本，可以去升级",
        "更新完立即重启": "更新完立即重启",
        "显示器进入休眠状态时重启": "显示器进入休眠状态时重启",
        "当显示器断开和所有的PC连接时重启": "当显示器断开和所有的PC连接时重启",
        "请输入机型名称": "请输入机型名称",
        "创建升级任务": "创建升级任务",
        "升级任务列表": "升级任务列表",
        "取消全部": "取消全部",
        "查看详情": "查看详情",
        "升级详情": "升级详情",
        "升级模式": "升级模式",
        "升级的创建时间": "升级的创建时间",
        "升级的开始时间": "升级的开始时间",
        "确认取消全部任务么？": "确认取消全部任务么？",
        "确认取消此任务么？": "确认取消此任务么？",
        "确认要删除选中的显示器吗？": "确认要删除选中的显示器吗？",
        "确认要删除所有显示器吗？": "确认要删除所有显示器吗？",
        "确认删除此信息吗（未分组无法删除）？": "确认删除此信息吗（未分组无法删除）？",
        "提示：显示器设置中若某选项变灰，有可能该选项是被其它选项的设置所制约，可以尝试改变其他设置以取消制约。": "提示：显示器设置中若某选项变灰，有可能该选项是被其它选项的设置所制约，可以尝试改变其他设置以取消制约。",
        "WebSocket 链接已断开，重连中...": "WebSocket 链接已断开，重连中...",
        "WebSocket 链接已重连成功！": "WebSocket 链接已重连成功！",
        "上一设置正在执行中，请等待数值变化后，再进行新的设置": "上一设置正在执行中，请等待数值变化后，再进行新的设置",
        
        "Ebook": "电子书",
        "largest": "最大",
        "Turn off auto mode": "关闭自动模式",

        "minimum": "Minim",
        "恢复出厂设置": "Resetare din fabrică",
        "场景模式": "Mod scenariu",
        "色温色域": "Gama și temperatura culorilor",
        "Panel native": "Afișați nativ",
        "Neutral(7500K)": "Neutru",
        "Reddish(6500K)": "Cald",
        "Bluish(9300K)": "Rece",
        "Neutral": "Neutru",
        "Reddish": "Cald",
        "Bluish": "Rece",
        "Low Blue Light": "Scădeți lumina albastră",
        "Custom 1": "Personalizat 1",
        "Custom 2": "Personalizat 2",
        "Custom 3": "Personalizat 3",
        "输入信号": "Semnal video",
        "游戏模式": "Mod pentru jocuri",
        "Off": "Dezactivat",
        "off": "Dezactivat",
        "Game 1": "Joc 1",
        "Game 2": "Joc 2",
        "响应时间": "Timp de raspuns",
        "Normal": "Normal",
        "Extreme": "Extrem",
        "Level 1": "Nivelul 1",
        "Level 2": "Nivelul 2",
        "Level 3": "Nivelul 3",
        "Level 4": "Nivelul 4",
        "Level 5": "Nivelul 5",
        "LAN指示灯": "Indicator LAN",
        'linked': 'Conectat',
        'nolink': 'Neconectat',
        'blinking': 'În conexiune',
        "亮度": "Contrast",
        "对比度": "Luminozitate",
        "智能感光": "Lumină inteligentă",
        "音量调节": "Controlul volumului",
        "USB模式": "Selectare USB",
        "DP模式": "Selectare DP",
        "显示比例": "Raportul de aspect",
        "智能交通灯": "Lumini inteligente",
        "菊花链": "Conectare în serie",
        "动态对比度": "Contrast dinamic",
        "智能能源": "Energie inteligentă",
        "智能音频": "Audio inteligent",
        "距离检测": "Avertizare de distanță",
        "环境光检测": "Detectarea luminii ambientale",
        "开启环境光检测": "Activare Detectarea luminii ambientale",
        "触摸唤醒": "Activare prin atingere",
        "硬分屏": "Ecran divizat hard-core",
        "人脸追踪": "Detectare facială",
        "音频智能开关": "Comutator audio inteligent",
        "自动警示": "Alertă automată",
        "KVM切换": "Comutator KVM",
        "KVM（键盘、显示器、鼠标）切换功能可以使用两台电脑使用一条显示器、键盘和鼠标，打开同时切换显示器、键盘鼠标功能，如果关闭此功能，则仅切换键盘和鼠标": "Comutatorul KVM (tastatură, video, mouse) permite 2 computere să utilizeze un singur monitor, tastatură și mouse, Activați simultan schimbarea videoclipurilor, tastaturii și mouse-ului. Dacă este dezactivat, comutați doar tastatura și mouse-ul",
        "久坐提醒": "Memento de mișcare",
        "Gaming": "Jocuri",
        "颜色调整": "Reglarea culorii",
        "序列号": "Numărul de serie",
        "固件版本号": "Versiunea softului",
        "选择响应时间等级": "Selectați nivelul timpului de răspuns",
        "启用菊花链": "Activare conectare în serie",
        "智能交通灯是一个请勿打扰灯，帮助降低干扰": "Luminile inteligente sunt niște lumini care nu deranjează, ajutând la reducerea distragerii",
        "启用/禁用音频智能开关": "Activare/dezactivare funcţia audio inteligent",
        "自动警示功能指示显示器上的摄像头/麦克风是否正在被使用": "Funcţia de alertă automată indică dacă aparatul foto/microfonul sunt activate",
        "开启距离检测": "Activare Avertizare de distanță",
        "打开或关闭人脸追踪功能": "Activare/dezactivare detectare facială",
        "开启久坐提醒": "Activare Memento de mișcare",
        "智能音频技术帮助你专注显示器正前方的声音，减少环境噪音，提高声音清晰度": "Tehnologia Audio inteligentă vă va permite să vă concentrați asupra sunetului din fața dvs. pentru a îmbunătăți claritatea vocii dvs",
        "智能能源技术通过人体传感器来帮助你自动管理显示器能源消耗": "Tehnologia cu Energie inteligentă gestionează automat consumul energiei prin senzorul de detectare umană",
        "硬分屏帮助你用一根线实现PBP功能": "PBP-ul se conectează printr-un singur cablu",
        "启用/禁用vPro功能": "Activare/dezactivare funcţia vPro",
        "通过触摸屏幕唤醒系统": "Activarea sistemului prin atingere",
        "为每台PC设置输入信号源和USB源": "Setați sursa video și sursa USB (tastatură și mouse) utilizate",
        "eKVM让您只需要同时按下鼠标的左右键，即可切换USB信号源": "eKVM va permite acces instantaneu la peste două surse de PC-uri doar printr-un simplu clic pe ambele butoane ale mouse-ului",
        "始终允许USB充电": "Activați încărcarea USB pornită continuu",
        "选择DP版本": "Selectare versiunea DP",
        "usb充电": "Încărcare USB",
        '电脑': 'ПК',
        "双击CTRL键": "Faceți dublu clic pe CTRL",
        "Full Screen": "Ecran complet",
        "Original AR": "AR original",
        "No scaling": "Fără scalare",
        "On": "On",
        "on": "On",
        "Keyboard On": "Tastatura activată",
        "Mouse On": "Mouse-ul activat",
        "Image Creation": "Crearea imaginii",
        "Digital Cinema": "Cinema digital",
        "Video Creation": "Creare video",
        "Web Browsing": "Navigare pe internet",
        "Professional Image": "Imagine profesională",
        "DisplayPort": "DisplayPort",
        "Auto": "Automat",
        "auto": "Automat",
        "Close PIP, PBP": "Dezactivat",
        // 安装包列表
        "刷新": "刷新",
        "搜索": "搜索",
        "记录": "记录",
        "用户名": "用户名",
        "上传时间": "上传时间",
        "增加配置": "增加配置",
        "最新更新包": "最新更新包",
        "上传更新包": "上传更新包",
        "上传": "上传",
        "大小": "大小",
        "上传成功": "上传成功",
        "下载成功": "下载成功",
        "刷新成功": "刷新成功",
        "升级包与机型不匹配": "升级包与机型不匹配",
        // 设置-配置文件
       
        // 用户管理
        "编辑": "编辑",
        "保存": "保存",
        "删除": "删除",
        "添加": "添加",
        "密码重置": "密码重置",
        "序号": "序号",
        "全名": "全名",
        "角色": "角色",
        "创建日期": "创建日期",
        "操作": "操作",
        "该用户的初始密码为": "该用户的初始密码为 ",
        "密码已经重置为": "密码已经重置为：",
        "请求参数不正确:用户名由 数字、字母 组成": "请求参数不正确:用户名由 数字、字母 组成",
        "请求参数不正确:用户名长度为 4-30 个字符": "请求参数不正确:用户名长度为 4-30 个字符",
        // 操作记录
        "安装包": "安装包",
        "操作日期": "操作日期",
        "操作内容": "操作内容",
        "操作人": "操作人",
        /* 翻译 -------------------------------------结束 */

        /* 机器翻译、不翻译 -------------------------------------开始 */
        "分页组件": "分页组件",
        "快速翻页": "快速翻页",
        "当前页": "当前页",
        "确定": "确 定",
        "取消": "取 消",
        "确 定": "确 定",
        "取 消": "取 消",
        "标题": "标题",
        "详细信息": "详细信息",
        "这是扩展区域": "这是扩展区域",
        "设置显示列": "设置显示列",
        "上传文件": "上传文件",
        "下拉展开": "下拉展开",
        "default": "默认",
        "默认信息": "默认信息",
        // aria-label
        "个人中心": "个人中心",
        "个人中心图片按钮": "个人中心图片按钮",
        "可展开区域": "可展开区域",
        "更新包表格": "更新包表格",
        "这是表格标头": "这是表格标头",
        "这是表格内容": "这是表格内容",
        "用户列表表格": "用户列表表格",
        "上下翻页": "上下翻页",
        "操作记录表格": "操作记录表格",
        "OSD升级详情": "OSD升级详情",
        /* 机器翻译、不翻译 -------------------------------------结束 */

        /* 固定翻译 -------------------------------------开始 */
        "8": "8",
        "20": "20",
        "250": "250",
        'Lenovo': 'Lenovo',
        'Display Fleet Manager': 'Display Fleet Manager',
        "高动态范围": "HDR",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gamma": "Gama",
        "PiP/PbP": "PIP/PBP",
        "OSD": "OSD",

        // OSD相关
        "USB-C充电": "USB-C charging",
        "PIP window": "PIP",
        "PBP window": "PBP",
        "PIP": "PIP",
        "PBP": "PBP",
        /* 固定翻译 -------------------------------------结束 */

        /* 语言包 -------------------------------------开始 */
        "简体中文": "简体中文",
        "英语": "英语",
        /* 语言包 -------------------------------------结束 */
    },
}